/* NB-002-WI */
(function () {
  'use strict';

  var configEl = document.getElementById('pdp-subscription-clarity-config');
  if (!configEl) return;

  function isIphoneDevice() {
    return /iPhone|iPod/i.test(navigator.userAgent || '');
  }

  if (!isIphoneDevice()) return;

  function activateClarity() {
    document.documentElement.classList.add('pdp-subscription-clarity-active');
    document.body.classList.add('pdp-subscription-clarity-active');

    var wyc = document.querySelector('[data-pdp-clarity="what-you-receive"]');
    if (wyc) wyc.hidden = false;
  }

  activateClarity();

  var config = {};
  var overrideEl = document.getElementById('pdp-subscription-clarity-settings');

  if (configEl) {
    try {
      config = JSON.parse(configEl.textContent);
    } catch (e) {}
  }

  if (overrideEl) {
    try {
      config = Object.assign({}, config, JSON.parse(overrideEl.textContent));
    } catch (e) {}
  }

  function applyWycCopyOverrides() {
    var root = document.querySelector('[data-pdp-clarity="what-you-receive"]');
    if (!root) return;

    var title = root.querySelector('.pdp-wyc-title');
    if (title && config.wycTitle) title.textContent = config.wycTitle;

    var todayTitle = root.querySelector('.pdp-wyc-card--green .pdp-wyc-card-title');
    if (todayTitle && config.todayCardTitle) todayTitle.textContent = config.todayCardTitle;

    var futureTitle = root.querySelector('.pdp-wyc-card--blue .pdp-wyc-card-title');
    if (futureTitle && config.futureCardTitle) futureTitle.textContent = config.futureCardTitle;

    var todayBottom = root.querySelector('.pdp-wyc-card--green .pdp-wyc-bottom-text');
    if (todayBottom && config.todayCardBottom) todayBottom.textContent = config.todayCardBottom;

    var futureBottom = root.querySelector('.pdp-wyc-card--blue .pdp-wyc-bottom-text');
    if (futureBottom && config.futureCardBottom) futureBottom.textContent = config.futureCardBottom;

    var todayItems = root.querySelectorAll('.pdp-wyc-card--green .pdp-wyc-item-main');
    var todayKeys = ['todayItem1', 'todayItem2', 'todayItem3', 'todayItem4'];
    todayItems.forEach(function (el, index) {
      if (config[todayKeys[index]]) el.innerHTML = config[todayKeys[index]];
    });

    var futureItems = root.querySelectorAll('.pdp-wyc-card--blue .pdp-wyc-item-main');
    var futureKeys = ['futureItem1', 'futureItem2', 'futureItem3', 'futureItem4'];
    futureItems.forEach(function (el, index) {
      if (config[futureKeys[index]]) el.innerHTML = config[futureKeys[index]];
    });
  }

  var WYC_NARROW_MAX = 1020;
  var planUiTimer = null;
  var oneTimePriceTimer = null;
  var wycResizeTimer = null;
  var loopOptionsObserved = false;
  var planUiDidInit = false;
  var enhancementsInitialized = false;

  function isNarrowView() {
    return window.innerWidth < WYC_NARROW_MAX;
  }

  function waitForElement(selector, callback) {
    var interval = setInterval(function () {
      if (document.querySelector(selector)) {
        clearInterval(interval);
        callback();
      }
    }, 180);
  }

  function getTrustAnchor() {
    var matches = document.querySelectorAll('div[class*="justify-evenly"]');
    for (var i = 0; i < matches.length; i++) {
      var el = matches[i];
      var t = el.textContent || '';
      if (t.indexOf('Try 30 days risk free') !== -1 && t.indexOf('Easily adjust shipment') !== -1) {
        return el;
      }
    }
    return null;
  }

  function getUvpContainer() {
    return document.querySelector('[class*="flex"][class*="justify-center"][class*="gap-[5px]"]');
  }

  function insertWhatYouReceive() {
    var narrow = isNarrowView();
    var anchor = getTrustAnchor();
    var uvpContainer = getUvpContainer();
    var existing = document.querySelector('[data-pdp-clarity="what-you-receive"]');

    if (existing) {
      existing.hidden = false;
      if (!narrow && uvpContainer) {
        if (uvpContainer.previousElementSibling !== existing) {
          uvpContainer.parentNode.insertBefore(existing, uvpContainer);
        }
      } else if (narrow && anchor) {
        if (anchor.nextElementSibling !== existing) {
          anchor.parentNode.insertBefore(existing, anchor.nextSibling);
        }
      }
      return true;
    }

    return false;
  }

  function addStarterGiftsCopy() {
    var matchText = config.giftsHeadingMatch || 'YOUR FREE GIFTS!';
    var headings = document.querySelectorAll('h3');
    var h3 = null;

    for (var i = 0; i < headings.length; i++) {
      if ((headings[i].textContent || '').indexOf(matchText) !== -1) {
        h3 = headings[i];
        break;
      }
    }

    if (!h3) return false;
    if (h3.parentElement && h3.parentElement.classList.contains('pdp-starter-gifts-wrapper')) return true;

    var wrapper = document.createElement('div');
    wrapper.className = 'pdp-starter-gifts-wrapper';
    var h3Clone = h3.cloneNode(true);
    wrapper.appendChild(h3Clone);

    var paragraph = document.createElement('p');
    paragraph.className = 'pdp-starter-gifts-copy text-[16px] text-[#333333] mb-4';

    var textSpan = document.createElement('span');
    textSpan.className = 'pdp-starter-gifts-copy__text';
    textSpan.textContent = config.giftsIntro || '';

    var badgesWrapper = document.createElement('span');
    badgesWrapper.className = 'pdp-starter-gifts-copy__badges';
    badgesWrapper.setAttribute('aria-label', "Today's order and future deliveries");

    var badgeToday = document.createElement('span');
    badgeToday.className = 'pdp-starter-gifts-badge pdp-starter-gifts-badge--today';
    badgeToday.textContent = config.badgeTodayLabel || "Today's order";

    var badgeFuture = document.createElement('span');
    badgeFuture.className = 'pdp-starter-gifts-badge pdp-starter-gifts-badge--future';
    badgeFuture.textContent = config.badgeFutureLabel || 'Future deliveries';

    badgesWrapper.appendChild(badgeToday);
    badgesWrapper.appendChild(badgeFuture);
    paragraph.appendChild(textSpan);
    paragraph.appendChild(badgesWrapper);
    wrapper.appendChild(paragraph);
    h3.parentNode.replaceChild(wrapper, h3);
    return true;
  }

  function savePercentFromInput(input) {
    var compare = parseInt(input.getAttribute('data-compare-price'), 10) || 0;
    var price = parseInt(input.getAttribute('data-price-value'), 10) || 0;
    return compare > 0 ? Math.max(0, Math.min(100, Math.round((1 - price / compare) * 100))) : null;
  }

  function injectSaveBadges() {
    var rows = document.querySelectorAll('.loop-subscription-options .loop-subscription-option');
    rows.forEach(function (row) {
      var input = row.querySelector('input[name="loop-subscription-option"]');
      if (!input || input.id === 'loop-subscription-option-one-time-purchase') return;

      var nameCol = row.querySelector('.loop-subscription-option-name');
      var title = row.querySelector('.loop-subscription-option-name-title');
      if (!nameCol || !title) return;

      var pct = savePercentFromInput(input);
      var rowWrap = nameCol.querySelector('.pdp-plan-title-row');

      if (!rowWrap) {
        rowWrap = document.createElement('div');
        rowWrap.className = 'pdp-plan-title-row';
        title.parentNode.insertBefore(rowWrap, title);
        rowWrap.appendChild(title);

        var badge = document.createElement('span');
        badge.className = 'pdp-plan-save-badge';
        badge.innerHTML =
          '<img src="' +
          (config.saveBadgeIconUrl || '') +
          '" alt="" width="14" height="14" loading="lazy">' +
          '<span class="pdp-plan-save-badge__label"></span>';
        rowWrap.appendChild(badge);
      }

      var badgeEl = rowWrap.querySelector('.pdp-plan-save-badge');
      var labelEl = rowWrap.querySelector('.pdp-plan-save-badge__label');
      if (!badgeEl || !labelEl) return;

      if (pct == null) {
        badgeEl.style.display = 'none';
      } else {
        badgeEl.style.display = '';
        labelEl.textContent = 'SAVE ' + pct + '%';
      }
    });
  }

  function installPlanRadio(bullet) {
    if (!bullet || bullet.getAttribute('data-pdp-plan-radio') === '1') return;
    bullet.setAttribute('data-pdp-plan-radio', '1');
    bullet.classList.add('pdp-plan-radio--svg');
    bullet.innerHTML = '';

    var off = document.createElement('span');
    off.className = 'pdp-plan-radio-stack pdp-plan-radio-stack--off';
    off.setAttribute('aria-hidden', 'true');
    off.innerHTML =
      '<img src="' + (config.radioOffUrl || '') + '" alt="" width="24" height="24" loading="lazy">';

    var on = document.createElement('span');
    on.className = 'pdp-plan-radio-stack pdp-plan-radio-stack--on';
    on.setAttribute('aria-hidden', 'true');
    on.style.display = 'none';
    on.innerHTML =
      '<img src="' + (config.radioOnUrl || '') + '" alt="" width="24" height="24" loading="lazy">';

    bullet.appendChild(off);
    bullet.appendChild(on);
  }

  function installAllPlanRadios() {
    document.querySelectorAll('.loop-subscription-option .loop-subscription-option-bullet').forEach(installPlanRadio);
  }

  function ensureSelectPlanTitle() {
    var container = document.querySelector('.loop-subscription-options-container');
    if (!container) return;

    var prev = container.previousElementSibling;
    if (prev && prev.getAttribute('data-pdp-clarity') === 'select-plan-title') return;

    var h = document.createElement('h2');
    h.className = 'pdp-select-plan-title';
    h.setAttribute('data-pdp-clarity', 'select-plan-title');
    h.textContent = config.selectPlanTitle || 'Select Plan:';
    container.parentNode.insertBefore(h, container);
  }

  function updateSubscriptionOptionText() {
    var subtitles = document.querySelectorAll('.loop-subscription-option-name-subtitle');
    subtitles.forEach(function (subtitle) {
      var row = subtitle.closest('.loop-subscription-option');
      if (!row || row.classList.contains('loop-subscription-option-one-time-purchase')) return;

      subtitle.textContent =
        config.subscriptionSubtitle ||
        'First order includes product + free starter gifts. Future orders include product only';

      var parent = subtitle.parentNode;
      if (parent && !parent.querySelector('.pdp-plan-cancel-line')) {
        var extraLine = document.createElement('div');
        extraLine.className = 'pdp-plan-cancel-line';
        extraLine.textContent = config.cancelLine || '✓ Skip, pause, or cancel anytime';
        parent.appendChild(extraLine);
      }
    });
    schedulePlanUi();
  }

  function updateOneTimePurchaseText() {
    var oneTimeOption = document.querySelector('.loop-subscription-option-one-time-purchase');
    if (!oneTimeOption) return false;

    var priceEl = oneTimeOption.querySelector('.loop-subscription-option-price-amount');
    var priceText = (priceEl && priceEl.textContent ? priceEl.textContent : '').trim() || '—';
    var nameDiv = oneTimeOption.querySelector('.loop-subscription-option-name');
    if (!nameDiv) return false;

    var subtitle = nameDiv.querySelector('.pdp-one-time-subtitle');
    if (!subtitle) {
      subtitle = document.createElement('div');
      subtitle.className = 'pdp-one-time-subtitle';
      nameDiv.appendChild(subtitle);
    }

    subtitle.textContent = priceText + (config.oneTimeSuffix || ' - No starter gifts included');
    return true;
  }

  function styleOneTimeLabel() {
    var oneTimeInput = document.getElementById('loop-subscription-option-one-time-purchase');
    var oneTimeLabel = oneTimeInput ? oneTimeInput.nextElementSibling : null;
    if (oneTimeLabel && !oneTimeLabel.classList.contains('pdp-one-time-label')) {
      oneTimeLabel.classList.add('pdp-one-time-label');
    }
  }

  function setOneTimeBodyClass() {
    var oneTime = document.getElementById('loop-subscription-option-one-time-purchase');
    var on = !!(oneTime && oneTime.checked);
    document.body.classList.toggle('pdp-one-time-selected', on);
  }

  function schedulePlanUi() {
    if (planUiTimer) clearTimeout(planUiTimer);
    planUiTimer = setTimeout(function () {
      injectSaveBadges();
      installAllPlanRadios();
    }, 120);
  }

  function scheduleOneTimeText() {
    requestAnimationFrame(function () {
      setTimeout(updateOneTimePurchaseText, 100);
    });
  }

  function observeLoopOneTimePrice() {
    var oneTime = document.querySelector('.loop-subscription-option-one-time-purchase');
    if (!oneTime || oneTime.dataset.pdpOneTimePriceObserved) return;
    oneTime.dataset.pdpOneTimePriceObserved = '1';

    function bind(priceEl) {
      if (!priceEl || priceEl.dataset.pdpPriceWatch) return;
      priceEl.dataset.pdpPriceWatch = '1';
      var obs = new MutationObserver(function () {
        if (oneTimePriceTimer) clearTimeout(oneTimePriceTimer);
        oneTimePriceTimer = setTimeout(updateOneTimePurchaseText, 0);
      });
      obs.observe(priceEl, {
        subtree: true,
        childList: true,
        characterData: true,
        attributes: true
      });
    }

    var priceEl = oneTime.querySelector('.loop-subscription-option-price-amount');
    if (priceEl) {
      bind(priceEl);
      return;
    }

    var wait = new MutationObserver(function () {
      var p = oneTime.querySelector('.loop-subscription-option-price-amount');
      if (p) {
        wait.disconnect();
        bind(p);
      }
    });
    wait.observe(oneTime, { childList: true, subtree: true });
    setTimeout(function () {
      try {
        wait.disconnect();
      } catch (e) {}
    }, 20000);
  }

  function observeLoopSubscriptionBlock() {
    var subBlock = document.querySelector('.loop-subscription-options');
    if (!subBlock || loopOptionsObserved) return;
    loopOptionsObserved = true;
    var obs = new MutationObserver(function () {
      schedulePlanUi();
    });
    obs.observe(subBlock, { childList: true, subtree: true });
  }

  function bindPlanChangeListeners() {
    document.querySelectorAll('input[name="loop-subscription-option"]').forEach(function (radio) {
      if (radio.dataset.pdpClarityBound) return;
      radio.dataset.pdpClarityBound = '1';
      radio.addEventListener('change', function () {
        scheduleOneTimeText();
        schedulePlanUi();
        setOneTimeBodyClass();
      });
    });

    document.querySelectorAll('input[name="flavour-image"], input[name="subscribe-save"]').forEach(function (radio) {
      if (radio.dataset.pdpClarityBound) return;
      radio.dataset.pdpClarityBound = '1';
      radio.addEventListener('change', function () {
        scheduleOneTimeText();
        schedulePlanUi();
      });
    });
  }

  function initPlanUi() {
    ensureSelectPlanTitle();
    installAllPlanRadios();
    injectSaveBadges();
    setOneTimeBodyClass();

    if (planUiDidInit) return;
    planUiDidInit = true;

    document.addEventListener(
      'change',
      function (e) {
        var t = e.target;
        if (t && t.name === 'loop-subscription-option') {
          setOneTimeBodyClass();
        }
      },
      true
    );

    var root = document.querySelector('.loop-subscription-options-container');
    if (root) {
      var obs = new MutationObserver(function () {
        if (planUiTimer) clearTimeout(planUiTimer);
        planUiTimer = setTimeout(function () {
          ensureSelectPlanTitle();
          installAllPlanRadios();
          injectSaveBadges();
          setOneTimeBodyClass();
          bindPlanChangeListeners();
        }, 0);
      });
      obs.observe(root, { childList: true, subtree: true });
    }
  }

  function initEnhancements() {
    if (enhancementsInitialized) {
      scheduleOneTimeText();
      schedulePlanUi();
      initPlanUi();
      return;
    }
    enhancementsInitialized = true;
    scheduleOneTimeText();
    schedulePlanUi();
    styleOneTimeLabel();
    bindPlanChangeListeners();
    observeLoopOneTimePrice();
    observeLoopSubscriptionBlock();
    initPlanUi();
  }

  function boot() {
    activateClarity();
    applyWycCopyOverrides();
    insertWhatYouReceive();
    addStarterGiftsCopy();
    updateSubscriptionOptionText();
    initEnhancements();
  }

  waitForElement('[data-pdp-clarity="what-you-receive"]', function () {
    insertWhatYouReceive();
  });

  waitForElement('h3', function () {
    addStarterGiftsCopy();
  });

  waitForElement('.loop-subscription-option-name-subtitle', function () {
    updateSubscriptionOptionText();
  });

  waitForElement('.loop-subscription-option-one-time-purchase', function () {
    initEnhancements();
  });

  waitForElement('.loop-subscription-options-container', function () {
    initEnhancements();
  });

  window.addEventListener(
    'resize',
    function () {
      if (!document.querySelector('[data-pdp-clarity="what-you-receive"]')) return;
      clearTimeout(wycResizeTimer);
      wycResizeTimer = setTimeout(insertWhatYouReceive, 120);
    },
    { passive: true }
  );

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      setTimeout(boot, 500);
    });
  } else {
    setTimeout(boot, 500);
  }
})();
